import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Category from "./pages/Category";
import Capsulas from "./pages/Capsulas";
import CapsulaDetail from "./pages/CapsulaDetail";
import Negocios from "./pages/Negocios";
import NegocioDetail from "./pages/NegocioDetail";
import Servicios from "./pages/Servicios";
import ServicioDetail from "./pages/ServicioDetail";
import Nosotros from "./pages/Nosotros";
import Cursos from "./pages/Cursos";
import ItinerarioDetail from "./pages/ItinerarioDetail";
import Contacto from "./pages/Contacto";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";
import Header from "./components/Header";
import FloatingChatWidget from "./components/FloatingChatWidget";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/categoria/:categorySlug" element={<Category />} />
          <Route path="/capsulas" element={<Capsulas />} />
          <Route path="/capsulas/:capsulaId" element={<CapsulaDetail />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/servicios/:serviceId" element={<ServicioDetail />} />
          <Route path="/negocios" element={<Negocios />} />
          <Route path="/negocios/:businessType" element={<NegocioDetail />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/cursos" element={<Cursos />} />
          <Route path="/cursos/:itinerarioId" element={<ItinerarioDetail />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/admin" element={<Admin />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <FloatingChatWidget />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
